module.exports = __webpack_public_path__ + "public/Icons/darkModenotVerified.svg?2a5b9ae3";